import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LocationSettingsMetadata } from '../interface/location-settings.interface';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class LocationSettingsService extends BaseService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  /** Fetch the Time Zone and Unit System dropdown options for the Add New Asset wizard (Step 2). */
  getLocationSettingsMetadata(): Observable<LocationSettingsMetadata> {
    return this.get<{ data: LocationSettingsMetadata }>(
      'location-settings'
    ).pipe(map(res => res.data));
  }
}
